<template>
  <q-layout view="hHh Lpr lff" class="custom-font">
    <q-header elevated>
      <q-toolbar class="pragma-black">
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="toggleLeftDrawer"
        />

        <q-toolbar-title>
          <div class="row">
            <div class="col-xs-12 text-center">
              <span class="text-subtitle1">TODAS LAS EMPRESAS</span> <br>
              <q-icon name="person"></q-icon><span class="text-subtitle2"> Aprob. Parcial</span> <br>
            </div>
          </div>
          
          
        </q-toolbar-title>
        <q-btn
          class="pragma-black pragma-text-black"
          flat
          v-if="route.name === 'searchAprobar'"
          icon="more_vert"
        ></q-btn>
        <q-btn flat color="white" icon="more_vert" v-if="route.name !== 'searchAprobar'">
          <q-menu class="bg-pragma-secon custom-font">
            <q-list style="min-width: 180px" dark separator dense>
              <q-item
                clickable
                v-close-popup
                @click="changePage(section)"
                v-for="section in sections"
                :key="section.name"
              >
                <div class="row full-width flex flex-center">
                  <div class="col-xs-2" :style="`color: #${section.color}`">
                    <q-icon name="circle"></q-icon>
                  </div>
                  <div class="col-xs-8">
                    {{ section.name }}
                  </div>
                  <div class="col-xs-2 text-right">
                    {{ section.cantidad }}
                  </div>
                </div>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>

      </q-toolbar>
    </q-header>
    
    <q-drawer
      v-model="show_drawer"
      :width="250"
      class="bg-blue-grey text-white"
    >
      <bar-menu-global />
    </q-drawer>
    <q-page-container>
      <detalle-solicitud />
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </q-page-container>
  </q-layout>
</template>

<script>
// import axios from 'axios'
import {inject, ref} from 'vue'
// import {useQuasar} from 'quasar'
import axios from 'axios'

// import util from '../../plugins/util'
import { useRoute } from 'vue-router'
import DetalleSolicitud from '../../views/global/pendientes/dialogs/DetalleSolicitudGlobalPendientes.vue'
import BarMenuGlobal from '../../components/BarMenuGlobal.vue'

export default {
  name: 'MainLayout',
  components: {
    DetalleSolicitud,
    BarMenuGlobal
  },
  setup () {
    // Variables reactivas y no reactivas
    // const $q = useQuasar()
    const bus = inject('bus')
    // const router = useRouter()
    const route = useRoute()

    const show_drawer = ref(false)
    const sections = ref([
      {
        name: 'PEN - 1',
        title: 'SOLICITUDES PENDIENTES',
        link: 'global/pendientes',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 2',
        title: 'SOLICITUDES PENDIENTES 2',
        link: 'global/pendientes2',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 3',
        title: 'SOLICITUDES PENDIENTES 3',
        link: 'global/pendientes3',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 4',
        title: 'SOLICITUDES PENDIENTES 4',
        link: 'global/pendientes4',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 5',
        title: 'SOLICITUDES PENDIENTES 5',
        link: 'global/pendientes5',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 6',
        title: 'SOLICITUDES PENDIENTES 6',
        link: 'global/pendientes6',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 7',
        title: 'SOLICITUDES PENDIENTES 7',
        link: 'global/pendientes7',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 8',
        title: 'SOLICITUDES PENDIENTES 8',
        link: 'global/pendientes8',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 9',
        title: 'SOLICITUDES PENDIENTES 9',
        link: 'global/pendientes9',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 10',
        title: 'SOLICITUDES PENDIENTES 10',
        link: 'global/pendientes10',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 11',
        title: 'SOLICITUDES PENDIENTES 11',
        link: 'global/pendientes11',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'PEN - 12',
        title: 'SOLICITUDES PENDIENTES 12',
        link: 'global/pendientes12',
        color: 'F39C12',
        cantidad: 0
      },
    ])

    // Métodos y funciones
    const changePage = (section) => {
      bus.emit('changePage', section)
    }

    const getEstadosEmpresa = async () => {
      let res = await axios.get(`json/cantidad/estados.global?section=global-pendientes`)
      sections.value.forEach(elem => {
        switch (elem.name) {
          case 'PEN - 1':
            elem.cantidad = res.data.pendientes
            break
          case 'PEN - 2':
            elem.cantidad = res.data.pendientes2
            break
          case 'PEN - 3':
            elem.cantidad = res.data.pendientes3
            break
          case 'PEN - 4':
            elem.cantidad = res.data.pendientes4
            break
          case 'PEN - 5':
            elem.cantidad = res.data.pendientes5
            break
          case 'PEN - 6':
            elem.cantidad = res.data.pendientes6
            break
          case 'PEN - 7':
            elem.cantidad = res.data.pendientes7
            break
          case 'PEN - 8':
            elem.cantidad = res.data.pendientes8
            break
          case 'PEN - 9':
            elem.cantidad = res.data.pendientes9
            break
          case 'PEN - 10':
            elem.cantidad = res.data.pendientes10
            break
          case 'PEN - 11':
            elem.cantidad = res.data.pendientes11
            break
          case 'PEN - 12':
            elem.cantidad = res.data.pendientes12
            break
        }
      })
    }

    // Creación del componente
    // Limpieza de eventos
    bus.all.clear()
    // util.verifyRol([8]) // Roles permitidos
    bus.on('recargaEstados', () => {
      getEstadosEmpresa()
    })
    getEstadosEmpresa()
    
    // Retorno de variables de la plantilla
    return {
      show_drawer,
      toggleLeftDrawer () {
        show_drawer.value = !show_drawer.value
      },
      changePage,
      route,
      sections
    }
  }
}
</script>

<style>
.estados {
  min-width: 40px;
}
</style>